import { payload } from "../../../../../../../node_modules/.pnpm/@sveltejs+kit@3.1.0_@opentelemetry+api@1.10.0_@sveltejs+vite-plugin-svelte@7.3.1_svelte_085dcdc5bf0ff3d60aa74d80b97d2b4e/node_modules/@sveltejs/kit/src/runtime/client/payload.js";
const env = payload.env;

export const PUBLIC_SANITY_DATASET = "ishavskraft-001";
export const PUBLIC_ALGOLIA_APP_ID = "TMYLA5Z44P";
export const PUBLIC_ALGOLIA_API_KEY = "ed4c345257ddc56dd193752ad447f2f3";
export const PUBLIC_ALGOLIA_INDEX_NAME = "ishavskraft_no";
export const PUBLIC_SANITY_STUDIO_URL = "http://localhost:3333";
